<template>
  <div class="mt-8 flex w-desktop gap-4">
    <div class="aui-bg-white shrink-0 basis-[397px] rounded-3xl p-6">
      <p class="mb-2 text-lg font-bold leading-[24px]">
        {{ $t('request-form.nothing-found.title') }}
      </p>
      <p class="mb-4">
        {{ $t('request-form.nothing-found.subtitle') }}
      </p>
      <AuiButton
        class="w-full"
        color="alt"
        type="button"
        @click="$emit('onOpenRequestFormModal')"
      >
        {{ $t('request-form.submit') }}
      </AuiButton>
    </div>
    <CashbackBanner @click="handleBannerClick" />
  </div>
</template>

<script setup lang="ts">
  import { AuiButton } from '@aviata/auiata';

  import { Analytics } from '@shared/analytics';
  import { analyticsEvents } from '../../shared';
  import CashbackBanner from './CashbackBanner.vue';

  const emit = defineEmits<{
    onOpenRequestFormModal: [];
    onOpenCashbackInfoModal: [];
  }>();

  const handleBannerClick = () => {
    Analytics.logEvent({
      event: analyticsEvents.CASHBACK_BANNER_CLICK,
    });

    emit('onOpenCashbackInfoModal');
  };
</script>
